<template>
<transition name="show">
    <div class="mapinfo" v-show="showflag">
		 <div class="loseplace">
		 	<el-input v-model="place"></el-input>
		 	<button class="btn" @click="change">{{$t('mapinfo.sure')}}</button>
		 </div>
		 <div id="allmap1"></div>
   </div>
</transition>
</template>
<script>
import axios from 'axios'
export default {
    name: "mapinfo",
    data(){
        return{
            place:"",
            lng:"",
            lat:"",
            showflag:false,
            local:[],
            slng:'',
            slat:''
        }
    },
    created(){
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function(r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            // console.log(r.point);
            this.slng = r.point.lng;
            this.slat = r.point.lat;
          } else {
            alert("failed" + this.getStatus());
          }
        },
        {
          enableHighAccuracy: true
        }
      );
    },
    mounted(){
      this.ready()
    },
    methods:{
    //定位
    ready: function() {
      var th = this;
      var map = new BMap.Map("allmap1");
			var point = new BMap.Point(this.slng,this.slat);
			map.centerAndZoom(point, 15);
      //map.centerAndZoom(new BMap.Point(113.76343399,23.04302382), 12);  // 初始化地图,设置中心点坐标和地图级别
	    // 设置地图显示的城市 此项是必须设置的
      map.enableScrollWheelZoom(true);
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function(r) {
          //console.log("定位：",r)
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            var mk = new BMap.Marker(r.point);
            map.addOverlay(mk);
            map.panTo(r.point);
            th.lng = r.point.lng;
            th.lat = r.point.lat;
          } else {
            alert("failed" + this.getStatus());
          }
        }
      );

      var geoc = new BMap.Geocoder();    
	    map.addEventListener("click", function(e){
		    var pt = e.point;
		    //console.log(e)
		    geoc.getLocation(pt, function(rs){
          var marker = new BMap.Marker(pt);
          if(th.local.length>=0){
            map.clearOverlays();
            th.local.shift()
          }
          map.addOverlay(marker)
          //console.log(rs)
          // axios.get('/user')
          // .then(function (response) {
          //   console.log(response);
          // })
          // .catch(function (error) {
          //   console.log(error);
          // });
          var addComp = rs.addressComponents;
          var site = addComp.province + addComp.city  + addComp.district  + addComp.street + addComp.streetNumber;
          th.place = site;
          th.local.push(site)
		});        
	});
    },
    showLocation(data){
      console.log(data)
    },
    change(){
        this.showflag=false
        this.$emit("adress", this.place)
    },
    show(){
        this.showflag = true
    }
  }
}
</script>
<style>
.loseplace .el-input__inner {
  font-size: 0.75rem;
  border-top-color: white;
  border-right-color: white;
  border-left-color: white;
}
.loseplace .el-input__inner:hover {
  border-top-color: white;
  border-right-color: white;
  border-left-color: white;
}
</style>
<style scoped>
.mapinfo{
  width: 100%;
height: 100%;
}
#allmap1{
width: 100%;
height: 100%;
overflow: hidden;
margin:0;
font-family:"微软雅黑";
}
.btn{
  color: #fff;
  background-color: #034694;
  width: 20%;
  border: 0;
  height:40px;
}
.loseplace{

  display:flex;
}
.mapinfo {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0px;
  width: 100%;
  z-index: 1002;
  background-color: #fff;
  transition: all 0.2s linear;
}
.mapinfo.show-enter,
.mapinfo.show-leave-to {
  transform: translateX(100%);
}
</style>


// WEBPACK FOOTER //
// src/m_page/myAccount/mapinfo.vue